<template>
  <v-container class="py-12">
    <TitleHeader> Publicações </TitleHeader>

    <v-row
      class="mt-12"
      justify="center"
      align="stretch"
      dense
    >
      <v-col
        v-for="(publicacao, index) in publicacoes"
        :key="index"
        cols="12"
        sm="6"
        md="4"
        class="d-flex justify-center"
      >
        <NavigationCard
          :icon="publicacao.internal ? 'mdi-file-document' : 'mdi-open-in-new'"
          :title="publicacao.title"
          :to="publicacao.internal ? publicacao.url : undefined"
          :href="!publicacao.internal ? publicacao.url : undefined"
          color="primary"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import TitleHeader from '@/components/TitleHeader.vue'
import NavigationCard from '@/components/NavigationCard.vue'

definePageMeta({
  middleware: 'manutencao',
  title: 'FUNARPEN - Publicações',
})

useHead({
  title: 'Publicações',
  meta: [
    {
      name: 'description',
      content: 'Acesse a legislação e os editais do FUNARPEN.',
    },
  ],
})

const publicacoes = [
  {
    title: 'Legislação',
    internal: true,
    url: '/funarpen/publicacoes/leis',
  },
  {
    title: 'Editais',
    internal: true,
    url: '/funarpen/publicacoes/editais',
  },
]
</script>
